module.exports = __webpack_public_path__ + "static/timeBg-c6cf3a7bac8285d8f0e4ace6585ea6c7.jpg";